<div *ngIf="wrapWithLabel; else checkboxOnly" class="checkbox-wrapper">
  <label>
    <ng-container *ngTemplateOutlet="checkboxOnly"></ng-container>
  </label>
</div>

<ng-template #checkboxOnly>
  <mat-checkbox
    [checked]="checked"
    (change)="onChanged($event.checked)"
    [disabled]="disabled">
    <ng-content></ng-content>
  </mat-checkbox>
</ng-template>
